import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import useDebounce from "../../../components/hooks/useDebounce";
import DynamicPaginatedTable from "../../../components/Tables/DynamicPaginatedTable";
import { setSearchKeys } from "../../../lib/slices/search_key_slice";
import { getCompanyAllClients } from "../../../services/company/authenticationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import { t } from "i18next";

const headerData = ["createdAt", "name", "email", "contact"];

const tableRows = ["created_date", "user_image_name", "email", "contact"];

const ClientList = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const userData = useSelector((state) => state.userData.user);
  const searchKey = useSelector((state) => state.SearchKeysReducer.searchKeys);
  const debouncedSearchTerm = useDebounce(
    searchKey.companyClientsUsername,
    1000
  );

  useEffect(() => {
    if (userData) {
      fetchAllReviews(debouncedSearchTerm);
    }
  }, [userData, debouncedSearchTerm]);

  const fetchAllReviews = async (name) => {
    try {
      setIsLoading(true);
      const response = await getCompanyAllClients(userData?.adminId, name);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllUsers(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    dispatch(
      setSearchKeys({
        ...searchKey,
        companyClientsUsername: e.target.value,
      })
    );
  };

  return (
    <React.Fragment>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("clientList")}
        secondaryHeading={t("viewClients")}
        showSerach={true}
        searchValue={searchKey.companyClientsUsername}
        onChange={handleSearchChange}
      >
        <DynamicPaginatedTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allUsers || []}
        />
      </AppContainer>
    </React.Fragment>
  );
};

export default ClientList;
